import { useEffect, useState } from "react";
import "../../../css/client/ClientDashboard.css";

import ClientTopBanner from "./ClientTopBanner";
import ClientProjectStatus from "./ClientProjectStatus";
import ClientTimeline from "./ClientTimeline";
import ClientMessages from "./ClientRecentMessages";
import ClientActionItems from "./ClientActionItems";
import ClientMeetings from "./ClientMeetings";
import ToolSidebar from "../../utils/ToolSideBar";
import { API_URL, authFetch } from "../../utils/auth";
import { currentUserCanUseMeetings } from "../../utils/features";

export default function ClientDashboard() {
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadDashboard() {
      try {
        const response = await authFetch(`${API_URL}/client/dashboard/`);
        const data = await response.json();
        if (!response.ok) throw new Error(data.detail || "Unable to load dashboard.");
        setDashboard(data);
        console.log(data)
      } catch (err) {
        console.error(err);
        setError(err.message || "Unable to load dashboard.");
      } finally {
        setLoading(false);
      }
    }

  useEffect(() => {
    loadDashboard();
  }, []);

  const project = dashboard?.project;

  return (
    <div className="dashboard-layout">
      <ToolSidebar active="dashboard" />
      <main className="client-dashboard">
        {loading ? (
          <div className="client-card"><h1>Loading dashboard...</h1></div>
        ) : error ? (
          <div className="client-card"><h1>Dashboard unavailable</h1><p>{error}</p></div>
        ) : (
          <>
            <ClientTopBanner user={dashboard?.user} project={project} />
            <div className="client-grid-top">
              <ClientProjectStatus project={project} />
              <ClientActionItems items={dashboard?.action_items || []} onUpdated={loadDashboard} />
            </div>
            <ClientTimeline milestones={dashboard?.milestones || []} progress={project?.progress_percentage || 0} summary={dashboard?.delivery_summary} />
            {dashboard?.active_offer && (
              <div className="client-card offer-summary-card">
                <h2>Active Offer</h2>
                <div className="detail-row"><span>Status</span><strong>{dashboard.active_offer.status_label}</strong></div>
                <div className="detail-row"><span>Total</span><strong>${dashboard.active_offer.total_amount}</strong></div>
                <div className="detail-row"><span>Paid</span><strong>${dashboard.active_offer.amount_paid}</strong></div>
                <div className="detail-row"><span>Remaining</span><strong>${dashboard.active_offer.remaining_balance}</strong></div>
              </div>
            )}
            <div className="client-grid-bottom">
              <ClientMessages messages={dashboard?.recent_messages || []} />
              {currentUserCanUseMeetings() && <ClientMeetings meetings={dashboard?.upcoming_meetings || []} />}
            </div>
          </>
        )}
      </main>
    </div>
  );
}